/**
 * Page de connexion BackOffice
 */

import { useState, FormEvent, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@e-store/shared';
import './LoginPage.css';

export function LoginPage() {
  const navigate = useNavigate();
  const { login, isAuthenticated, user } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [infoMessage, setInfoMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isAuthenticated && user) {
      if (user.mustChangePassword) {
        navigate('/change-password');
      } else {
        navigate('/dashboard');
      }
    }
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setInfoMessage('');
    setIsSubmitting(true);

    const result = await login({ email, password, portal: 'backoffice' });

    if (!result.success) {
      // Cas spécial: mustChangePassword avec email envoyé
      if (result.mustChangePassword && result.emailSent) {
        setInfoMessage('Un email vous a été envoyé pour définir votre nouveau mot de passe.');
        setIsSubmitting(false);
        return;
      }
      setError(result.error || 'Erreur de connexion');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>E-Store</h1>
          <h2>BackOffice</h2>
        </div>

        {error && <div className="error-message">{error}</div>}

        {infoMessage && (
          <div
            className="info-message"
            style={{
              background: '#dbeafe',
              color: '#1e40af',
              border: '1px solid #93c5fd',
              padding: '12px 16px',
              borderRadius: '8px',
              marginBottom: '16px',
            }}
          >
            {infoMessage}
            <p style={{ marginTop: '8px', fontSize: '14px' }}>
              Veuillez consulter votre boîte mail. N'oubliez pas de vérifier vos spams.
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email ou Nom d'utilisateur</label>
            <input
              type="text"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com ou votre_username"
              required
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Votre mot de passe"
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="btn-primary" disabled={isSubmitting}>
            {isSubmitting ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="login-links">
          <Link to="/forgot-password" className="link">
            Mot de passe oublié ?
          </Link>
        </div>
      </div>
    </div>
  );
}
